import React, { Fragment } from "react";
import { AUTO_PLAN_RC } from "../constants/auto.constant";
import { AIG_AUTO, AUTO_HOME_PREMIUM, AUTO_X_KM, PRACTIAUTO } from "../constants/cotizacion.constant";
import { INSPECCION_MENSAJE_AUTOINSPECCION, INSPECCION_MENSAJE_AUTOINSPECCION_VIRTUAL, INSPECCION_MENSAJE_PRESENCIAL, INSPECCION_MENSAJE_VARIOS_TIPOS, INSPECCION_VALOR_AUTOINSPECCION_MAX, INSPECCION_VALOR_PRESENCIAL_MAX, INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MAX, INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MIN, INSPECCION_VALOR_VARIOS_TIPOS_MAX, INSPECCION_VALOR_VARIOS_TIPOS_MIN } from "../constants/inspeccion.constant";


export const generarMensajeInspeccion = (carrito = null) => {
  if (!carrito.carProductos) return segmentarMensajeInspeccion(
    carrito.carDescripcionSeguro, 
    carrito.valorAsegurado, 
    null
  ); 

  const mensajes = [];

  carrito.carProductos.forEach((item, index) => {
    if (item.datosProducto.valorAsegurado === 0) return;

    let planPoliza = null;
    if (item.datosCalculoScoring.plan) planPoliza = item.datosCalculoScoring.plan
    
    const detalleMensajeInspeccion = {
      index: index,
      item: item,
      carDescripcionSeguro: carrito.carDescripcionSeguro,
      planPoliza: planPoliza
    };
    mensajes.push(obtenerMensajeFinalInspeccion(detalleMensajeInspeccion));
  });
  
   mensajes.push(
    <div key="mensaje-final">
      <p>
        El cliente recibirá en el email que se registró para el contratante,
        un correo electrónico con las instrucciones para realizar el proceso.
      </p>

      <p>
        <strong>IMPORTANTE:</strong> revisar el buzón de correos no deseados
        si no lo recibe dentro de 5 minutos de iniciado el proceso de inspección.
      </p>
    </div>
  );


  return (
    <Fragment>
      {mensajes}
    </Fragment>
  );
}

export const segmentarMensajeInspeccion = (carDescripcionSeguro, sumaAseguradaTotal, planPoliza) => {
  if (!carDescripcionSeguro || !sumaAseguradaTotal) return '';

  switch (carDescripcionSeguro) {
    case PRACTIAUTO:
    case AUTO_HOME_PREMIUM:
    case AUTO_X_KM:
      return validarYObtenerMensajeInspeccion(sumaAseguradaTotal);
    
    case AIG_AUTO:
      if (planPoliza === AUTO_PLAN_RC) return INSPECCION_MENSAJE_AUTOINSPECCION;
      return validarYObtenerMensajeInspeccion(sumaAseguradaTotal);

    default:
      return 'No se encontró el método de inspección';
  }
}

export const validarYObtenerMensajeInspeccion = (sumaAseguradaTotal) => {
  if (sumaAseguradaTotal <= INSPECCION_VALOR_AUTOINSPECCION_MAX) return INSPECCION_MENSAJE_AUTOINSPECCION;

  if (
    sumaAseguradaTotal >= INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MIN &&
    sumaAseguradaTotal <= INSPECCION_VALOR_PRESENCIAL_VIRTUAL_MAX
  ) return INSPECCION_MENSAJE_AUTOINSPECCION_VIRTUAL;

  if (sumaAseguradaTotal >= INSPECCION_VALOR_PRESENCIAL_MAX) return INSPECCION_MENSAJE_PRESENCIAL;
  
  return INSPECCION_MENSAJE_PRESENCIAL;
}

export const obtenerMensajeFinalInspeccion = (detalleMensajeInspeccion) => {
  const index = detalleMensajeInspeccion.index;
  const item = detalleMensajeInspeccion.item;
  const carDescripcionSeguro = detalleMensajeInspeccion.carDescripcionSeguro;
  const planPoliza = detalleMensajeInspeccion.planPoliza;
  
  return (
    <div key={index} style={{ marginBottom: "20px" }}>
      El ítem <strong>{item.datosProducto.placa} - {item.datosProducto.marca} {item.datosProducto.modelo}</strong>, 
      con producto cotizado <strong>{carDescripcionSeguro}</strong>, 
      por su suma asegurada <span dangerouslySetInnerHTML={{
          __html: segmentarMensajeInspeccion(
            carDescripcionSeguro,
            item.datosProducto.valorAsegurado,
            planPoliza
          )
        }}
      />.
    </div>
  );
}
